import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "./api";
import { ProfileThumb, roleLabel } from "./ProfileLibrary";

const Part = ({ p, slot }) => (
  <div className="rounded-lg border border-zinc-800 bg-[#121215] p-3" data-testid={`bway-part-${slot}`}>
    <ProfileThumb p={p} className="h-24" />
    <div className="mt-2 flex items-baseline justify-between"><span className="font-[Manrope] text-sm font-bold text-white">{p.code}</span><span className="font-mono text-[10px] text-zinc-500">{p.weight_kg_m} kg/m</span></div>
    <div className="text-[11px] capitalize text-amber-400/80">{slot.replace("_", " ")} · {roleLabel(p.role)}</div>
  </div>
);

export default function BwaySystemInfo() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/bway/system").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader2 className="h-6 w-6 animate-spin text-zinc-500" />;
  return (
    <div className="space-y-6" data-testid="bway-system-info">
      <div className="rounded-lg border border-zinc-800 bg-[#121215] p-4 text-sm text-zinc-300">
        <div className="mb-2 font-mono text-[11px] uppercase tracking-wider text-zinc-500">Layer stack, inside to outside</div>
        <p data-testid="bway-stack">Mullion tube → 3460 glazing adaptor (clips over the 25 mm tube) → inner EPDM → glass 18–32 mm → outer EPDM → SA: 8012 outer box + 3459 end cap · SB: 19 mm cap · SC: flush silicone joint</p>
      </div>
      <div className="grid gap-3 md:grid-cols-3">
        {Object.entries(d.series).map(([k, v]) => (
          <div key={k} className="rounded-lg border border-zinc-800 p-3" data-testid={`bway-series-${k}`}>
            <div className="font-[Manrope] font-bold text-white">{k}</div>
            <div className="text-xs text-zinc-400">{v}</div>
            <div className="mt-1 font-mono text-[10px] text-zinc-500">Catalogue inner {d.catalogue[k]?.inner} mm · outer SA {d.catalogue[k]?.outer.SA} / SB {d.catalogue[k]?.outer.SB} / SC {d.catalogue[k]?.outer.SC} mm</div>
          </div>
        ))}
        <div className="rounded-lg border border-dashed border-zinc-800 p-3 text-xs text-zinc-500" data-testid="bway-series-2550S">2550S (inner 63 mm) needs the 50 × 25 tube drawing, which hasn't been uploaded yet.</div>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {d.tubes.map((p) => <Part key={p.id} p={p} slot="mullion tube" />)}
        {Object.entries(d.parts).map(([slot, p]) => <Part key={slot} p={p} slot={slot} />)}
      </div>
      <div className="grid gap-2 text-xs text-zinc-400 md:grid-cols-3">
        {Object.entries(d.variants).map(([k, v]) => <div key={k} className="rounded border border-zinc-800 p-2" data-testid={`bway-variant-${k}`}>{v}</div>)}
      </div>
    </div>
  );
}
